export default __webpack_public_path__ + "static/media/SOCIALSECURITYCERTIFICATE_BACK.a1adb518.png";